import React, { useState, useRef, useEffect } from 'react'
import { Input } from 'reactstrap'
import { BsSearch, BsClock, BsCalendar3, BsChevronDown, BsBell } from "react-icons/bs";
import { AiOutlineLogout } from "react-icons/ai";
import { WiDayHail } from "react-icons/wi";
import { LogOut } from '../general/General';
import Langs from '../../utilities/Langs';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changeLang } from '../../redux/slices/langSlice';
import Logout from '../general/Logout';

const HeaderRight = () => {
    const [search, setSearch] = useState('')
    const [isLangOpen, setIsLangOpen] = useState(false)
    const [isLogoutOpen, setIsLogoutOpen] = useState(false)
    const langRef = useRef(null)
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const { lang } = useSelector((state) => state.lang)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (langRef.current && !langRef.current.contains(event.target)) {
                setIsLangOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const handleLanguageChange = (language) => {
        dispatch(changeLang(language))
        setIsLangOpen(false)
    }

    return (
        <div className='header-right'>
            {/* <div className='form-element'>
                <BsSearch size={18} />
                <Input
                    type='text'
                    placeholder={t("make_search")}
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div> */}
            {/* <div className='dw'>
                <div><BsCalendar3 size={17} className='pr-1' /><span>{new Date().toLocaleDateString()}</span></div>
                <div><BsClock size={17} className='pr-1' /><span>{new Date().getHours()}:{new Date().getMinutes()}</span></div>
                <div><WiDayHail size={17} className='pr-1' /><span>15°</span></div>
            </div> */}
            <div className='select-lang position-relative cp' ref={langRef}>
                <div onClick={() => setIsLangOpen(!isLangOpen)} className='d-flex justify-content-center align-items-center'>
                    <span className='f12'>{lang.toUpperCase()}</span>
                    <div className='ml-1'><BsChevronDown size={14} /></div>
                </div>
                {isLangOpen && (
                    <div className='lang-dropdown shadow'>
                        {Langs.map((language) => (
                            <div
                                key={language}
                                className='lang-item'
                                onClick={() => handleLanguageChange(language)}
                            >
                                <span className='f14'>{language.toUpperCase()}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {/* <div className='icon-item'><BsBell size={16} /></div> */}
            <div className='icon-item cp' onClick={() => setIsLogoutOpen(!isLogoutOpen)}><AiOutlineLogout size={16} /></div>
            <Logout isLogoutOpen={isLogoutOpen} setIsLogoutOpen={setIsLogoutOpen} />
        </div>
    )
}

export default HeaderRight
